import { Component, Input, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { TreeViewComponent } from '@syncfusion/ej2-angular-navigations';

import { CerFormView } from '@form/cer-form-view';
import { UiCommandEvent } from '@ui/cer-ui-types';
import { ICerFormViewType } from './cer-form-view-type.interface';
import { CerAppRouteService } from 'src/cer-app/cer-app-route/cer-app-route.service';

@Component({
  selector: 'cer-form-view-type-tree',
  templateUrl: './cer-form-view-type-tree.component.html',
})
export class CerFormViewTypeTreeComponent implements OnDestroy, ICerFormViewType {

  constructor(private r: CerAppRouteService) {
    r.setIsLoading(false);
  }
  
  @ViewChild(TemplateRef<any>) template!: TemplateRef<any>;
  
  public treeView: TreeViewComponent = null;
  @ViewChild(TreeViewComponent, { static: false }) set setViewChildList(treeView: TreeViewComponent) {
    if (treeView && this.treeView != treeView) {
      this.treeView = treeView;
      if (this.view != null) {
        //this.view.appComponent = this;
      }
    }
  }

  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    if (view && this._view != view) {
      this._view = view;
      this.viewSubscription = this._view.commandSubscribe(e => this.onCommand(e));
    }
  }

  private viewSubscription: Subscription;
  public ngOnDestroy(): void {
    this.viewSubscription.unsubscribe();
  }

  public onCommand(e: UiCommandEvent) {
    //if (this.treeView != null && this.treeView.id != e.appComponent?.id) {
      //this.treeView.onViewCommand(e);
    //}
  }

  protected onComponentCommand(e: UiCommandEvent) {
    if (this.view != null) {
      this.view.triggerCommand(e);
    }
  }
}

